<template>
  <div class="message">
    <el-dialog
      title="建议"
      top="15%"
      :visible.sync="dialogVisible"
      width="30%"
      @close="close"
      @input="descInput"
      center>
      <el-input
        maxlength="200"
        @input="descInput"
        v-model="form.content"
        type="textarea"
        :rows="10"
        placeholder="对于渠道无忧有任何建议或者意见，欢迎留言！">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">提 交</el-button>
      </span>
      <span style="float: right">{{remnant}}/200</span>
    </el-dialog>
  </div>
</template>
<script>
  import Api from '@/api/client/message'
  import {FormArgument} from '@/models/client/message'
  export default {
    props: {
      visible: {
        type: Boolean
      }
    },
    watch: {
      visible () {
        this.dialogVisible = this.visible
      }
    },
    data () {
      return {
        remnant: 200,
        dialogVisible: this.visible,
        form: new FormArgument()
      }
    },
    methods: {
      descInput () {
        let txtVal = this.form.content.length
        this.remnant = 200 - txtVal
      },
      submit () {
        if (this.form.content !== '') {
          Api.list({'form': this.form}, response => {
            let status = response.status
            if (status >= 200 && status <= 204) {
              this.$message.success('留言成功！')
            } else {
              this.$message.error('留言失败！')
            }
          })
          this.close()
        } else {
          this.$message.error('请填写留言！')
        }
        this.form.content = ''
      },
      close () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>
<style lang="scss">
  .message{
    .el-dialog__title{
      font-weight:600;
    }
    .el-button--primary{
      padding: 7px 35px;
    }
    .el-dialog--center .el-dialog__body{
      padding:42px 75px 20px;
    }
    .el-dialog__header{
      padding:40px 20px 10px;
    }
    .el-dialog__footer{
      padding: 10px 20px 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/Message.vue